import { useState } from "react";
import { toast } from "sonner";
import api, { apiError } from "../lib/api";
import { useLang } from "../lib/i18n";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";

const EMPTY = { current_password: "", new_password: "", confirm: "" };

export default function ChangePasswordDialog({ open, onOpenChange }) {
  const { t } = useLang();
  const [form, setForm] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (form.new_password !== form.confirm) return toast.error(t("passwordMismatch"));
    setBusy(true);
    try {
      const { data } = await api.post("/auth/change-password", {
        current_password: form.current_password, new_password: form.new_password,
      });
      if (data.token) localStorage.setItem("apha_token", data.token);
      toast.success(t("passwordChanged"));
      setForm(EMPTY);
      onOpenChange(false);
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm" aria-describedby={undefined} data-testid="change-password-dialog">
        <DialogHeader><DialogTitle className="font-heading">{t("changePassword")}</DialogTitle></DialogHeader>
        <form className="space-y-3" onSubmit={submit}>
          <div className="space-y-1"><Label>{t("currentPassword")}</Label>
            <Input type="password" autoComplete="current-password" data-testid="current-password-input"
              value={form.current_password} onChange={set("current_password")} required /></div>
          <div className="space-y-1"><Label>{t("newPassword")} <span className="text-muted-foreground">({t("passwordMinHint")})</span></Label>
            <Input type="password" autoComplete="new-password" data-testid="new-password-input"
              value={form.new_password} onChange={set("new_password")} minLength={8} required /></div>
          <div className="space-y-1"><Label>{t("confirmPassword")}</Label>
            <Input type="password" autoComplete="new-password" data-testid="confirm-password-input"
              value={form.confirm} onChange={set("confirm")} required /></div>
          <Button type="submit" data-testid="change-password-submit" className="w-full bg-[#1E3A8A] hover:bg-[#1c3479]" disabled={busy}>
            {busy ? "..." : t("save")}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
